export const QueryParamsConst = {
  ORDER: "order",
  PAGE: "page",
  PER_PAGE: "take",
  QUERY: "q",
  FILTERS: "filters",
  SORT: "sort"
};
